import { Component, OnInit, AfterViewInit, Input, ViewChild } from '@angular/core';
// import { GlobalService } from '../../../services/global.service';
// import { MessageService } from '../../../services/message.service';
// import { GraphService } from '../../../services/graphs.service';
// import { Observable } from 'rxjs';
// import { ConfigModel } from 'src/app/models/graphs.model';
// import { WellsModel } from 'src/app/models/wells.model';
// import { Location, ViewportScroller } from '@angular/common';
// import { filter } from 'rxjs/operators';
// import { Router, Scroll } from '@angular/router';

@Component({
    selector: 'app-ehs-personal-safety',
    templateUrl: './personalSafety.component.html',
    styleUrls: ['../../home/home.component.scss'],
})
export class PersonalSafetyComponent implements OnInit, AfterViewInit {

    ehsActualHarm_highlights: string = "";
    
    @Input() ehs_Injury_Yellow: number;
    @Input() ehs_Injury_Orange: number;
    @Input() ehs_Injury_Max: number;
    @Input() ehs_Injury_Text: string;
    @Input() ehs_Injury_CurrentYearValue: number;
    @Input() ehs_Injury_LastYearValue: number;
    @Input() ehs_CurrentYear: number;
    majorTicks: string = "0,2,4,6,8,10";

    constructor(
        // private globals: GlobalService,
        // private graph: GraphService,
        // private router: Router, private viewportScroller: ViewportScroller,
        // private messageService: MessageService
        ) {
    }        

    ngOnInit(): void {
    }

    ngOnDestroy(event) {
    } 

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.refresh();
        })
    }

    refresh(): void {
        this.ehsActualHarm_highlights = '[{"from": 0, "to": ' + this.ehs_Injury_Yellow + ', "color": "rgba(255, 255, 77, .75)"},';
        this.ehsActualHarm_highlights += '{"from": ' + this.ehs_Injury_Yellow + ', "to": ' + this.ehs_Injury_Orange + ', "color": "rgba(255, 153, 0, .75)"},';
        this.ehsActualHarm_highlights += '{"from": ' + this.ehs_Injury_Orange + ', "to": ' + this.ehs_Injury_Max + ', "color": "rgba(255, 51, 51, .75)"} ]'

        let step: number = 1;
        let reminder = this.ehs_Injury_Max % 2;
        if (reminder == 0) {
            //evenNumber = true;
            step = 2;
        }
        
        this.majorTicks = "0";
        for (var i=step; i<=this.ehs_Injury_Max; i+=step) {
            this.majorTicks += "," + i;
        }

    }

}